import { action, observable, runInAction } from 'mobx';
import { informerController } from './informerController';
import {
  UpdateInformerInterface,
  BaseInformerInterface,
  InformerItemInterface,
} from '../api/informerApi';

export interface InformerStore {
  informers: InformerItemInterface[],
  error: any,
  currentInformer: InformerItemInterface,
}

export const informerStore: InformerStore = observable({
  informers: [],
  error: null,
  currentInformer: null,
} as InformerStore);

export const informerActions = {

  getInformers: async (showDeleted:boolean = false): Promise<void> => {
    const response = await informerController.getInformers(showDeleted);
    informerActions.handleError(response);
    runInAction(() => {
      informerStore.informers = response.data;
    });
  },

  clearInformers: action(() => {
    informerStore.informers = [];
  }),

  createInformer: async (request: BaseInformerInterface): Promise<void> => {
    const response = await informerController.createInformer(request);
    informerActions.handleError(response);
  },

  updateInformer: async (request: UpdateInformerInterface): Promise<void> => {
    const response = await informerController.updateInformer({
      ...request,
    });
    informerActions.handleError(response);
  },

  deleteInformer: async (id: string): Promise<void> => {
    const response = await informerController.deleteInformer(id);
    informerActions.handleError(response);
  },

  restoreInformer: async (id: string): Promise<void> => {
    const response = await informerController.restoreInformer(id);
    informerActions.handleError(response);
  },

  clearError: action(() => {
    informerStore.error = null;
  }),

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      informerStore.error = errorData;
      throw errorData;
    }
  }),

  setCurrentInformer: action((item: InformerItemInterface) => {     
    informerStore.currentInformer = item;
  }),

  clearCurrentInformer: action(() => {
    informerStore.currentInformer = null;
  }),

};
